// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__Yfl7z","content":"styles_content__QSPgX","breadcrumb":"styles_breadcrumb__+Ll+I","mainContent":"styles_mainContent__RYq+W","footer":"styles_footer__70O6W"};